import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-textarea-widget',
  templateUrl: './sf-textarea-widget.component.html'
})
export class TextAreaWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/textarea/sf-textarea-widget.component.ts